import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Operation,
  RawOperation,
} from "../../pages/ActivityPage/ui/ActivityTable/types/types";

interface ActivityDetailsState {
  isOpen: boolean;
  operation?: Operation;
  /** @deprecated See `RawOperation`. */
  rawOperation?: RawOperation;
}

const initialState: ActivityDetailsState = {
  isOpen: false,
};

const activityDetailsSlice = createSlice({
  name: "activityDetails",
  initialState,
  reducers: {
    setIsActivityDetailModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    updateActivityDetailModalOperation: (
      state,
      action: PayloadAction<ActivityDetailsState["operation"]>,
    ) => {
      state.operation = action.payload;
    },
    /** @deprecated See `RawOperation`. */
    updateActivityDetailModalRawOperation: (
      state,
      action: PayloadAction<ActivityDetailsState["rawOperation"]>,
    ) => {
      state.rawOperation = action.payload;
    },
  },
});

export const {
  setIsActivityDetailModalOpen,
  updateActivityDetailModalOperation,
  updateActivityDetailModalRawOperation,
} = activityDetailsSlice.actions;

export default activityDetailsSlice.reducer;
